<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Payment Terminal</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSave()">

  <div class="modal-body">
    <div class="form-group">
      <label for="labelInput">Label</label>
      <input id="labelInput" type="text" class="form-control" name="label"
             required
             [(ngModel)]="reader.label">
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            *ngIf="!loadingSubmit">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

  </form>

</ng-container>
